<template>
    <gestion>
        <div class="space-y-6 sm:px-6 lg:px-0 lg:col-span-9">
            <section aria-labelledby="instruction_free">
                <div class="shadow sm:rounded-md sm:overflow-hidden">
                    <div class="relative bg-white max-w-7xl mx-auto lg:grid lg:grid-cols-5">
                        <div class="bg-gray-50 py-8 px-4 sm:px-6 lg:col-span-2 lg:px-8">
                            <div class="max-w-lg mx-auto">
                                <h2 id="instruction_free" class="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">
                                    {{ $t('gestion.instruction.free.title') }}
                                </h2>
                                <p class="mt-3 leading-6 text-gray-500" v-html="$t('gestion.instruction.free.text1')" />
                                <p class="mt-3 leading-6 text-gray-500">
                                    {{ $t('gestion.instruction.free.text2') }}
                                </p>
                                <p class="mt-3 leading-6 text-gray-500">
                                    {{ $t('gestion.instruction.free.text3') }}
                                </p>
                            </div>
                        </div>
                        <div class="bg-white py-8 px-4 sm:px-6 lg:col-span-3 lg:px-8">
                            <div class="max-w-lg mx-auto lg:max-w-none">
                                <form class="grid grid-cols-1 gap-y-6" @submit.prevent="sendEmailFree">
                                    <ui-input
                                        id="email_host"
                                        name="email"
                                        type="email"
                                        :placeholder="$t('gestion.instruction.free.email')"
                                        autocomplete="email"
                                        v-model="emailFree.email"
                                    >
                                        <div class="text-sm text-red-500" v-if="emailFree.errors.email">
                                            {{ $t(emailFree.errors.email[0]) }}
                                        </div>
                                    </ui-input>
                                    <ui-textarea
                                        id="message_host"
                                        name="message"
                                        :rows="26"
                                        :placeholder="$t('gestion.instruction.free.message')"
                                        v-model="emailFree.content"
                                    >
                                        <div class="text-sm text-red-500" v-if="emailFree.errors.content">
                                            {{ $t(emailFree.errors.content[0]) }}
                                        </div>
                                    </ui-textarea>
                                    <div>
                                        <activix-button :loading="emailFree.processing" color="indigo" type="submit">
                                            {{ $t('forms.button.send') }}
                                        </activix-button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section aria-labelledby="instruction_dns">
                <div class="shadow sm:rounded-md sm:overflow-hidden">
                    <div class="relative bg-white max-w-7xl mx-auto lg:grid lg:grid-cols-5">
                        <div class="bg-gray-50 py-8 px-4 sm:px-6 lg:col-span-2 lg:px-8">
                            <div class="max-w-lg mx-auto">
                                <h2 id="instruction_dns" class="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">
                                    {{ $t('gestion.instruction.dns.title') }}
                                </h2>
                                <p class="mt-3 leading-6 text-gray-500">
                                    {{ $t('gestion.instruction.dns.text1') }}
                                </p>
                                <p class="mt-3 leading-6 text-gray-500">
                                    {{ $t('gestion.instruction.dns.text2') }}
                                </p>
                                <p class="mt-3 leading-6 text-gray-500">
                                    {{ $t('gestion.instruction.dns.text3') }}
                                </p>
                                <p class="mt-3 leading-6 text-gray-500">
                                    {{ $t('gestion.instruction.dns.text4') }}
                                </p>
                                <p class="mt-3 leading-6 text-gray-500">
                                    {{ $t('gestion.instruction.dns.text5') }}
                                </p>
                            </div>
                        </div>
                        <div class="bg-white py-8 px-4 sm:px-6 lg:col-span-3 lg:px-8">
                            <div class="max-w-lg mx-auto lg:max-w-none">
                                <form class="grid grid-cols-1 gap-y-6" @submit.prevent="sendEmailDns">
                                    <ui-input
                                        id="email_dns"
                                        name="email"
                                        type="email"
                                        :placeholder="$t('gestion.instruction.dns.email')"
                                        autocomplete="email"
                                        v-model="emailDns.email"
                                    >
                                        <div class="text-sm text-red-500" v-if="emailDns.errors.email">
                                            {{ $t(emailDns.errors.email[0]) }}
                                        </div>
                                    </ui-input>
                                    <ui-textarea
                                        id="message_dns"
                                        name="message"
                                        :rows="26"
                                        :placeholder="$t('gestion.instruction.dns.message')"
                                        v-model="emailDns.content"
                                    >
                                        <div class="text-sm text-red-500" v-if="emailDns.errors.content">
                                            {{ $t(emailDns.errors.content[0]) }}
                                        </div>
                                    </ui-textarea>
                                    <div>
                                        <activix-button :loading="emailDns.processing" color="indigo" type="submit">
                                            {{ $t('forms.button.send') }}
                                        </activix-button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </gestion>
</template>

<script>
    import Gestion from '@/layouts/Gestion.vue';
    import ActivixButton from '@/components/ui/ActivixButton.vue';
    import UiInput from '@/components/ui/UiInput.vue';
    import UiTextarea from '@/components/ui/UiTextarea.vue';

    export default {
        components: {
            Gestion,
            ActivixButton,
            UiInput,
            UiTextarea,
        },

        props: {
            account: {
                type: Object,
                default: () => {},
            },
            auth: {
                type: Object,
                default: () => {},
            },
        },

        data() {
            return {
                emailFree: this.$inertia.form({
                    type: 'free',
                    email: null,
                    content: this.$t('gestion.instruction.free.content', {
                        user: this.auth.user.name,
                        organisation: this.account.title,
                        email: this.account.email,
                        download: this.$route('download', this.account.sid),
                    }),
                }),
                emailDns: this.$inertia.form({
                    type: 'dns',
                    email: null,
                    content: this.$t('gestion.instruction.dns.content', {
                        user: this.auth.user.name,
                        organisation: this.account.title,
                        email: this.account.email,
                    }),
                }),
            };
        },

        methods: {
            sendEmailFree() {
                this.emailFree
                    .post(this.$route('gestion.instruction.store', this.account.sid), {
                        onSuccess: () => this.$notify.success(this.$t('general.sended')),
                    });
            },

            sendEmailDns() {
                this.emailDns
                    .post(this.$route('gestion.instruction.store', this.account.sid), {
                        onSuccess: () => this.$notify.success(this.$t('general.sended')),
                    });
            },
        },
    };
</script>
